var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOutlookIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 2457,
  height: 2500,
  fillRule: "evenodd",
  clipRule: "evenodd",
  imageRendering: "optimizeQuality",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  viewBox: "0 0 6876 6994"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0072c6",
  d: "M0 779 4033 0l-14 6994L0 6160zm1430 3632c-305-357-390-918-244-1384 203-648 718-867 1149-717 246 86 465 293 582 610 56 152 86 326 88 503 4 318-106 692-324 953-335 400-903 441-1250 35zm314-339c-150-223-191-573-120-864 99-404 352-541 563-447 121 54 228 183 285 381 27 95 42 203 43 314 2 198-52 432-159 595-164 250-442 275-612 22zm2552-2598h2341c131 0 238 107 238 238v86L5035 3039c-24 16-83 62-132 93-72 47-77 38-153-5-117-65-319-203-455-297V1474zm2580 875v2504c0 200-164 365-365 365H4296V3366c133 88 310 204 419 271 88 54 104 79 202 22 45-26 89-60 119-80l1840-1229z"
})));
export { SvgOutlookIcon as ReactComponent };
export default __webpack_public_path__ + "357a061bdc33d0bc5906e6045a4c1abf.svg";